import React, { useState } from "react";
import { Tabs, Tab, Box, Button, Typography } from "@mui/material";
import InProcess from "./InProcess";
import Pending from "./Pending";
import Completed from "./Completed";
import UseGetLaPatientData from "../../helper/UseGetLaPatientData";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import CustomModal from "../CustomModal/CustomModal";
import AddExternalLabReports from "../ModalChildren/AddExternalLabReports";
import AddIcon from "@mui/icons-material/Add";
import External from "./External";
import { tabStyle } from "../../style/PatientReportStyle";

const TabComponent = () => {
  const [value, setValue] = useState(0);
  const [testDate, setDateTest] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const { data: getLapPatient, isLoading } = UseGetLaPatientData(testDate);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: "90vw",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "neutral.blueShadeBg",
        margin: "auto",
        borderRadius: "20px",
      }}
    >
      <Box
        sx={{
          justifyContent: "space-between",
          width: "100%",
          display: "flex",
          mt: 2,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            backgroundColor: "neutral.blueShadeBg",
            borderRadius: "20px",
            minHeight: "56px",
            display: "flex",
            paddingX: "10px",
            alignItems: "center",
            "& .MuiTabs-flexContainer": {
              alignItems: "center",
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "neutral.teal",
              height: "2px",
              // borderRadius: "4px",
            },
          }}
        >
          <Tab label="Processing" sx={tabStyle} />
          <Tab label="Pending" sx={tabStyle} />
          <Tab label="Completed" sx={tabStyle} />
          <Tab label="External" sx={tabStyle} />
        </Tabs>

        {/* <Box sx={{ paddingTop: 2, marginRight: 4 }} >
          <Button sx={{
            ...primaryBtnTeal, gap: 1, display: 'flex', alignItems: 'center', paddingY: 2.6, textTransform: "none",
          }} onClick={() => setModalVisible(true)} >
            < AddIcon />
            <Typography>Add external report</Typography></Button>
        </Box> */}
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto",
        }}
      >
        {value === 0 && (
          <InProcess
            isLoading={isLoading}
            testDate={testDate}
            data={getLapPatient?.inprocess}
          />
        )}
        {value === 1 && (
          <Pending
            isLoading={isLoading}
            testDate={testDate}
            data={getLapPatient?.pending_tests}
          />
        )}
        {value === 2 && (
          <Completed
            setDateTest={setDateTest}
            data={getLapPatient?.completed_tests}
            testDate={testDate}
          />
        )}
        {value === 3 && <External modalVisible={modalVisible} />}
      </Box>

      <CustomModal
        customStyles={{ border: "none", width: "85%" }}
        open={modalVisible}
        onClose={() => {
          setModalVisible(false);
        }}
      >
        <AddExternalLabReports
          onClose={() => {
            setModalVisible(false);
          }}
        />
      </CustomModal>
    </Box>
  );
};

export default TabComponent;
